// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../rescript/lib/es6/curry.js";
import * as Generic$ApiTypes from "../utils/Generic.bs.js";

var partial_arg = [
  [
    "InsertModeReplace",
    /* InsertModeReplace */0
  ],
  [
    "InsertModeAppend",
    /* InsertModeAppend */1
  ]
];

function insertMode_toJson(param) {
  return Generic$ApiTypes.Encode.simpleVariant(partial_arg, param);
}

var insertMode_fromJson = Generic$ApiTypes.Decode.simpleVariant([
      [
        "InsertModeReplace",
        /* InsertModeReplace */0
      ],
      [
        "InsertModeAppend",
        /* InsertModeAppend */1
      ]
    ]);

function toJson(param) {
  return Curry._1(Generic$ApiTypes.Encode.object, [
              [
                "topbarTarget",
                Generic$ApiTypes.Encode.nullable(param.topbarTarget, Generic$ApiTypes.Encode.string)
              ],
              [
                "topbarTargetStyle",
                Generic$ApiTypes.Encode.nullable(param.topbarTargetStyle, Generic$ApiTypes.Encode.string)
              ],
              [
                "topbarZIndex",
                Generic$ApiTypes.Encode.nullable(param.topbarZIndex, Generic$ApiTypes.Encode.$$int)
              ],
              [
                "topbarContainerTarget",
                Generic$ApiTypes.Encode.nullable(param.topbarContainerTarget, Generic$ApiTypes.Encode.string)
              ],
              [
                "topbarThreeColumnLayout",
                Generic$ApiTypes.Encode.nullable(param.topbarThreeColumnLayout, Generic$ApiTypes.Encode.bool)
              ],
              [
                "topbarHomeEnabled",
                Curry._1(Generic$ApiTypes.Encode.bool, param.topbarHomeEnabled)
              ],
              [
                "topbarInsertMode",
                Curry._1(insertMode_toJson, param.topbarInsertMode)
              ],
              [
                "topbarEnabled",
                Curry._1(Generic$ApiTypes.Encode.bool, param.topbarEnabled)
              ],
              [
                "hamburgerTarget",
                Generic$ApiTypes.Encode.nullable(param.hamburgerTarget, Generic$ApiTypes.Encode.string)
              ],
              [
                "hamburgerTargetStyle",
                Generic$ApiTypes.Encode.nullable(param.hamburgerTargetStyle, Generic$ApiTypes.Encode.string)
              ],
              [
                "hamburgerZIndex",
                Generic$ApiTypes.Encode.nullable(param.hamburgerZIndex, Generic$ApiTypes.Encode.$$int)
              ],
              [
                "hamburgerContainerTarget",
                Generic$ApiTypes.Encode.nullable(param.hamburgerContainerTarget, Generic$ApiTypes.Encode.string)
              ],
              [
                "hamburgerTriggerButtonTarget",
                Generic$ApiTypes.Encode.nullable(param.hamburgerTriggerButtonTarget, Generic$ApiTypes.Encode.string)
              ],
              [
                "hamburgerHomeEnabled",
                Curry._1(Generic$ApiTypes.Encode.bool, param.hamburgerHomeEnabled)
              ],
              [
                "injectCSS",
                Generic$ApiTypes.Encode.nullable(param.injectCSS, Generic$ApiTypes.Encode.string)
              ],
              [
                "injectJS",
                Generic$ApiTypes.Encode.nullable(param.injectJS, Generic$ApiTypes.Encode.string)
              ],
              [
                "breakpointMaxWidth",
                Generic$ApiTypes.Encode.nullable(param.breakpointMaxWidth, Generic$ApiTypes.Encode.$$int)
              ]
            ]);
}

var fromJson = Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._2(Generic$ApiTypes.Decode.andMap, Curry._1(Generic$ApiTypes.Decode.succeed, (function (topbarTarget, topbarTargetStyle, topbarZIndex, topbarContainerTarget, topbarThreeColumnLayout, topbarHomeEnabled, topbarInsertMode, topbarEnabled, hamburgerTarget, hamburgerTargetStyle, hamburgerZIndex, hamburgerContainerTarget, hamburgerTriggerButtonTarget, hamburgerHomeEnabled, injectCSS, injectJS, breakpointMaxWidth) {
                                                                            return {
                                                                                    topbarTarget: topbarTarget,
                                                                                    topbarTargetStyle: topbarTargetStyle,
                                                                                    topbarZIndex: topbarZIndex,
                                                                                    topbarContainerTarget: topbarContainerTarget,
                                                                                    topbarThreeColumnLayout: topbarThreeColumnLayout,
                                                                                    topbarInsertMode: topbarInsertMode,
                                                                                    topbarEnabled: topbarEnabled,
                                                                                    topbarHomeEnabled: topbarHomeEnabled,
                                                                                    hamburgerTarget: hamburgerTarget,
                                                                                    hamburgerTargetStyle: hamburgerTargetStyle,
                                                                                    hamburgerContainerTarget: hamburgerContainerTarget,
                                                                                    hamburgerTriggerButtonTarget: hamburgerTriggerButtonTarget,
                                                                                    hamburgerZIndex: hamburgerZIndex,
                                                                                    hamburgerHomeEnabled: hamburgerHomeEnabled,
                                                                                    injectCSS: injectCSS,
                                                                                    injectJS: injectJS,
                                                                                    breakpointMaxWidth: breakpointMaxWidth
                                                                                  };
                                                                          })), Curry._2(Generic$ApiTypes.Decode.field, "topbarTarget", Curry._1(Generic$ApiTypes.Decode.option, Generic$ApiTypes.Decode.string))), Curry._2(Generic$ApiTypes.Decode.field, "topbarTargetStyle", Curry._1(Generic$ApiTypes.Decode.option, Generic$ApiTypes.Decode.string))), Curry._2(Generic$ApiTypes.Decode.field, "topbarZIndex", Curry._1(Generic$ApiTypes.Decode.option, Generic$ApiTypes.Decode.$$int))), Generic$ApiTypes.Decode.fieldWithDefault("topbarContainerTarget", Curry._1(Generic$ApiTypes.Decode.option, Generic$ApiTypes.Decode.string), undefined)), Generic$ApiTypes.Decode.fieldWithDefault("topbarThreeColumnLayout", Curry._1(Generic$ApiTypes.Decode.option, Generic$ApiTypes.Decode.bool), undefined)), Generic$ApiTypes.Decode.fieldWithDefault("topbarHomeEnabled", Generic$ApiTypes.Decode.bool, false)), Generic$ApiTypes.Decode.fieldWithDefault("topbarInsertMode", insertMode_fromJson, /* InsertModeReplace */0)), Generic$ApiTypes.Decode.fieldWithDefault("topbarEnabled", Generic$ApiTypes.Decode.bool, true)), Curry._2(Generic$ApiTypes.Decode.field, "hamburgerTarget", Curry._1(Generic$ApiTypes.Decode.option, Generic$ApiTypes.Decode.string))), Curry._2(Generic$ApiTypes.Decode.field, "hamburgerTargetStyle", Curry._1(Generic$ApiTypes.Decode.option, Generic$ApiTypes.Decode.string))), Curry._2(Generic$ApiTypes.Decode.field, "hamburgerZIndex", Curry._1(Generic$ApiTypes.Decode.option, Generic$ApiTypes.Decode.$$int))), Generic$ApiTypes.Decode.fieldWithDefault("hamburgerContainerTarget", Curry._1(Generic$ApiTypes.Decode.option, Generic$ApiTypes.Decode.string), undefined)), Generic$ApiTypes.Decode.fieldWithDefault("hamburgerTriggerButtonTarget", Curry._1(Generic$ApiTypes.Decode.option, Generic$ApiTypes.Decode.string), undefined)), Generic$ApiTypes.Decode.fieldWithDefault("hamburgerHomeEnabled", Generic$ApiTypes.Decode.bool, false)), Curry._2(Generic$ApiTypes.Decode.field, "injectCSS", Curry._1(Generic$ApiTypes.Decode.option, Generic$ApiTypes.Decode.string))), Curry._2(Generic$ApiTypes.Decode.field, "injectJS", Curry._1(Generic$ApiTypes.Decode.option, Generic$ApiTypes.Decode.string))), Curry._2(Generic$ApiTypes.Decode.field, "breakpointMaxWidth", Curry._1(Generic$ApiTypes.Decode.option, Generic$ApiTypes.Decode.$$int)));

var NavMenu = {
  insertMode_toJson: insertMode_toJson,
  insertMode_fromJson: insertMode_fromJson,
  toJson: toJson,
  fromJson: fromJson
};

export {
  NavMenu ,
}
/* insertMode_fromJson Not a pure module */
